import { useState } from "react";
import {
  useCmsFollowMember,
  useCmsUnfollowMember,
} from "../../../js/api/follow-member/follow-member.js";
import { toast } from "../../../js/components/toast.js";
import { queryClient } from "../../../js/api/queryClient.js";

const useQueryInvalidation = (queriesToInvalidate) => {
  return async (callback) => {
    if (Array.isArray(queriesToInvalidate) && queriesToInvalidate.length > 0) {
      await queryClient.invalidateQueries({ queryKey: queriesToInvalidate });
    }
    callback();
  };
};

export function useToggleFollowMember({
  memberId,
  isFollowed,
  followingMessage,
  queriesToInvalidate,
  useFollowingsData,
  isFollowingsUserFollowing,
}) {
  const [isSpinnerVisible, setIsSpinnerVisible] = useState(false);
  const [isUserFollowing, setIsUserFollowing] = useState(isFollowed);

  const cmsFollowMemberMutation = useCmsFollowMember();
  const cmsUnfollowMemberMutation = useCmsUnfollowMember();
  const invalidateQueries = useQueryInvalidation(queriesToInvalidate);

  const handleSuccess = (isFollowing, followingMessage) => {
    setIsUserFollowing(isFollowing);

    invalidateQueries(() => {
      setIsSpinnerVisible(false);
      if (isFollowing && followingMessage) {
        toast.success(null, followingMessage);
      }
    });
  };

  const handleError = () => setIsSpinnerVisible(false);

  const handleUnfollow = () => {
    cmsUnfollowMemberMutation.mutateAsync({
      id: memberId,
      successHandler: () => handleSuccess(false),
      errorHandler: handleError,
    });
  };

  const handleFollow = () => {
    cmsFollowMemberMutation.mutateAsync({
      id: memberId,
      successHandler: () => handleSuccess(true, followingMessage),
      errorHandler: handleError,
    });
  };

  const isCurrentlyFollowing = useFollowingsData ? isFollowingsUserFollowing : isUserFollowing;

  const toggleClickHandler = () => {
    setIsSpinnerVisible(true);

    if (isCurrentlyFollowing) {
      handleUnfollow();
    } else {
      handleFollow();
    }
  };

  return {
    isSpinnerVisible,
    isUserFollowing,
    toggleClickHandler,
  };
}
